/**
 * Boxes as printed on ICS 232-CG (Jan 2026), Resources at Risk Summary.
 *
 * Boxes 4 and 5 are each a site table followed by its own Narrative blank, so
 * they share the same columns and differ only by the category stored per row.
 */
export const ICS232_BOX_LABELS = {
  incidentName: '1. Incident Name:',
  incidentLocation: '2. Incident Location:',
  operationalPeriod: '3. Operational Period (Date/Time):',
  environmental: '4. Environmentally Sensitive Areas and Wildlife Concerns:',
  socioeconomic: '5. Archaeo-Cultural and Socio-economic Issues:',
  preparedBy: '6. Prepared by:',
} as const;

/** Columns of the site tables in boxes 4 and 5. */
export const ICS232_SITE_COLUMNS = [
  { key: 'site_number', label: 'Site #' },
  { key: 'priority', label: 'Priority' },
  { key: 'site_name_location', label: 'Site Name and Physical Location' },
  { key: 'site_issues', label: 'Site Issues' },
] as const;

/** `category` on a site row, which decides whether it prints in box 4 or 5. */
export const ICS232_CATEGORIES = {
  environmental: 'environmental',
  socioeconomic: 'socioeconomic',
} as const;
